import { lazy } from 'react';

import LightAuthLayout from 'layout/LightAuthLayout';
import Loadable from 'ui-component/Loadable';

const AuthLogin = Loadable(lazy(() => import('views/Authentication/Auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/Authentication/Auth/Register')));

// Authentication routes must not own '/': the public landing page is the only
// route allowed to handle the site root.
const AuthRoutes = [
  { path: '/login', element: <LightAuthLayout />, children: [{ index: true, element: <AuthLogin /> }] },
  { path: '/panel/login', element: <LightAuthLayout />, children: [{ index: true, element: <AuthLogin /> }] },
  { path: '/register', element: <LightAuthLayout />, children: [{ index: true, element: <AuthRegister /> }] },
  { path: '/panel/register', element: <LightAuthLayout />, children: [{ index: true, element: <AuthRegister /> }] }
];

export default AuthRoutes;
